<template>
    <v-container>
    <v-row align="center" justify="center" style="height: 100%">
      <v-col cols="12" lg="4" xl="3" align-self="center">
        <v-card style="border-radius: 8px;" elevation="24" class="pa-5">
          <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
          <v-list-item>
            <v-img src="logo.png"/>
          </v-list-item>
          <v-list-item class="crmTitle">
            <h1>CRM</h1>
          </v-list-item>
          <v-divider></v-divider>
          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-text-field
                :autofocus="true"
                prepend-icon="mdi-account"
                label="E-mail"
                type="text"
                v-model="access.email"
                required
              />
              <v-text-field
                
                prepend-icon="mdi-lock"
                label="Senha"
                type="password"
                v-model="access.password"
                @keypress.enter="getIn()"
                required
              />
              <v-btn
                rounded
                class="black mt-4 white--text"
                block
                @click="getIn()"
              >
                <span> Entrar </span>
              </v-btn>
            </v-form>
          </v-card-text>
          <v-spacer style="border-bottom:1px solid grey; margin-bottom:10px;"></v-spacer>
           <v-row>
                <v-col cols=6>
                    <span style="cursor:pointer;" class="forgotPasswordLink" @click="forgotPassword = !forgotPassword">Esqueci minha senha <span style="color:red; fon-size:19px;">*</span> </span>
                </v-col>
            </v-row>
        </v-card>
      </v-col>
    </v-row>
    <!-- modal recuperação de senha -->
    <v-dialog v-model="forgotPassword" max-width="600">
        <v-card>
            <v-card-title style="font-size:14px;">
                Um link será enviado para o seu e-mail.
            </v-card-title>
            <v-card-text>
                <v-text-field prepend-icon="mdi-email" placeholder="E-mail" v-model="access.email"></v-text-field>
            </v-card-text>
            <v-card-actions style="padding-top:0;padding-bottom:20px; justify-content:end;">
                <v-btn color="black" style="color:white;" @click="redefinePasswordEmail()">
                    Enviar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import login from '../../src/app/login'
import recoverPassword from '../../src/app/usuario/redefinePassword'
import translate from '../../src/plugins/translate'
import getLibtranslate from '../../src/app/translate/getLibtranslate'
import getAllLanguages from '../../src/app/idioma/getAllLanguages'
import updateUserCompany from '../../src/app/empresa_usuario/updateUserCompany'
import { createNamespacedHelpers } from 'vuex'

const user = createNamespacedHelpers('user')

export default {
    name: 'homePage',
    data() {
        return {
            loading:false,
            userChooseDialog: false,
            changedlanguage: null,
            languageSelected: null,
            logo: require('../../src/assets/logoGrey.png'),
            grey_bar_steps: require('../../src/assets/grey_bar_steps.png'),
            principal_image: require('../../src/assets/principalImage.png'),
            access: {
				email: '',
				password: '',
			},
            selectLabel: translate('Selecione', 'homePage'),
            idiomas: [],
            userinstances: [],
            baseUrl: process.env.VUE_APP_API_URL,
            forgotPassword : false,
            factory: require('../../src/assets/system/factory.png'),
            valid: null
        };
    },
    methods: {
        ...user.mapActions(['setUser']),
        async getIn() {
			this.loading = true
            try{
                await login(this.access).then(function(response){
                this.user = response.data
                if(response.data.instances.length > 1) {
                    this.loading = false
                    this.forceUserToChoose(response.data.instances)
                } else return this.setUserAndSignIn(response.data.instances[0])
            }.bind(this))
            }catch{
                this.loading = false
            }
		},
        forceUserToChoose(data) {
            this.userinstances = data
            this.userChooseDialog = true
        },
        async redefinePasswordEmail(){
            this.laoding = true
            await recoverPassword({email : this.access.email}).then(() => {
                this.forgotPassword = false
                this.loading = false
            })
        }
        ,
        async setUserAndSignIn(instance) {
            // o loading só termina quando a tela seguinte foi aberta
            this.loading = true
            try {
                delete this.user.instances
                this.user = Object.assign(this.user, instance)
                localStorage.setItem('user', JSON.stringify(this.user))
                this.setUser()
                this.user.ULTIMO_ACESSO = new Date()
                await updateUserCompany(Object.assign(this.user, {alterDate:true}))
                // a biblioteca carregada na tela de login não conhece a empresa/idiomas do usuário
                if(this.user.language) localStorage.setItem('language', JSON.stringify(this.user.language))
                try {
                    await getLibtranslate(this.user.EMPRESA_ID)
                } catch (e) { /* segue com a biblioteca já carregada */ }
                var lastPath = null
                if(localStorage.getItem('goTo')){
                    lastPath = localStorage.getItem('goTo')
                    localStorage.setItem('goTo','')
                }
                await this.$router.push(lastPath ? lastPath : '/atendimentos')
            } finally {
                this.loading = false
            }
        },
        changeLanguage(changedlanguage) {
            this.languageSelected = changedlanguage ? changedlanguage : this.languageSelected
            if(this.languageSelected) localStorage.setItem('language', JSON.stringify(this.languageSelected || null))
        },
        goTo(url){
            if(url != window.location.pathname) this.$router.push(url)
        },
        activateInputFields(){
        // Isso foi desenvolvido para corrigir um erro de UI do vuetify no Chrome, onde os labels e os valores dos campos ficavam sobrepostos antes do usuário interagir com a tela.
            setTimeout(() => {
                const els = document.querySelectorAll("input:-webkit-autofill")
                els.forEach((el) => {
                    const label = el.parentElement.querySelector("label")
                    label.classList.add("v-label--active")
                })
                }, 500)
        }
    }
    ,
    async mounted() {
        this.loading = true
        try {
            const savedUser = JSON.parse(localStorage.getItem('user') || '{}')
            if(savedUser.TOKEN) {
                const lastPath = localStorage.getItem('goTo')
                localStorage.setItem('goTo', '')
                this.$router.replace(lastPath || '/atendimentos')
                return
            }
        } catch (e) { /* sessão inválida, segue para o login */ }
        if(localStorage.getItem('language') && localStorage.getItem('language') != 'undefined'){
            this.changedlanguage = JSON.parse(localStorage.getItem('language'))
            this.languageSelected = JSON.parse(localStorage.getItem('language'))
        } 
        await getLibtranslate()
        await getAllLanguages('pattern')
            .then(function(response){
                if(!localStorage.getItem('language')) localStorage.setItem('language', JSON.stringify(response.data[0] || null)) 
                this.idiomas = response.data
                localStorage.setItem('idiomas', JSON.stringify(this.idiomas))
            }.bind(this))
        this.loading = false
        this.activateInputFields()
    },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Baloo+2&display=swap');
.crmTitle>h1{
    font-family:'Baloo 2', cursive;
    font-size:20px;
    color: grey;
}
.container {
  height: 100vh;
}
.v-image {
  left: 10px;
}
.forgotPasswordLink:hover{
    color:black;
}
</style>
